"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyncOptions = void 0;
var SyncOptions;
(function (SyncOptions) {
    SyncOptions[SyncOptions["PREFER_CACHE"] = 0] = "PREFER_CACHE";
    SyncOptions[SyncOptions["SYNC_ALWAYS"] = 1] = "SYNC_ALWAYS";
    SyncOptions[SyncOptions["NEVER_SYNC"] = 2] = "NEVER_SYNC";
})(SyncOptions = exports.SyncOptions || (exports.SyncOptions = {}));
//# sourceMappingURL=streamopts.js.map